module.exports = __webpack_public_path__ + "static/media/user-icon.7b5036b5.svg";